<template>
  <div class="account-page">
    <button class="account-back" type="button" @click="back" aria-label="Back">
      <img src="../../static/images/back.png" alt="">
    </button>

    <main class="account-main">
      <header class="account-title-wrap">
        <img src="../../static/images/account/user_center_title.png" alt="User Center">
      </header>

      <section class="account-user">
        <div class="account-avatar-wrap">
          <img class="account-avatar" :src="info.avatar" alt="">
          <span class="account-camera" aria-hidden="true">
            <img src="../../static/images/account/camera.png" alt="">
          </span>
          <input class="upload-image" type="file" @change="handleFileUpload" accept="image/*" aria-label="Upload image">
        </div>
        <div class="account-nickname">
          <div v-if="isEdit" class="account-edit-form">
            <input v-model="nickname" class="account-name-input">
            <button type="button" class="account-submit" @click="editSub">{{$t('Submit')}}</button>
          </div>
          <div v-else class="account-name-display">
            <span>{{info.nickname}}</span>
            <button type="button" class="account-edit" @click="editName" aria-label="Edit profile">
              <img src="../../static/images/account/edit.png" alt="">
            </button>
          </div>
        </div>
      </section>

      <section class="account-stats" :aria-label="$t('Points')">
        <div class="account-stat">
          <img src="../../static/images/account/rank.png" alt="">
          <span>{{$t('Rank')}}</span>
          <strong>{{info.rank}}</strong>
        </div>
        <div class="account-stat-divider"></div>
        <div class="account-stat">
          <img src="../../static/images/home/pts.png" alt="">
          <span>{{$t('Points')}}</span>
          <strong>{{info.points}}</strong>
        </div>
        <div class="account-stat-divider"></div>
        <div class="account-stat">
          <img src="../../static/images/home/chance.png" alt="">
          <span>{{$t('Chances')}}</span>
          <strong>{{info.score}}</strong>
        </div>
      </section>

      <section class="account-details">
        <div class="account-detail-row">
          <span>{{$t('phoneNumber')}}</span>
          <strong>{{info.mobile}}</strong>
        </div>
        <div class="account-detail-row">
          <span>{{$t('Level')}}</span>
          <strong>{{info.level}}</strong>
        </div>
        <div class="account-detail-row">
          <span>{{$t('MemberSince')}}</span>
          <strong>{{info.jointime}}</strong>
        </div>
        <p v-if="show_usub" class="account-unsub-tip">{{$t('unsub_tip')}}</p>
      </section>

      <section class="account-language" :aria-label="$t('language')">
        <h2>Choose Your Language</h2>
        <div class="account-language-options">
          <button type="button" class="account-language-option" :class="{ 'is-selected': isShowLang === 'en' }" @click="changeLanguage('en')">
            <img :src="isShowLang === 'en' ? '../../static/images/account/en_langauge_select.png' : '../../static/images/account/en_langauge.png'" alt="English">
            <span>{{$t('English')}}</span>
          </button>
          <button type="button" class="account-language-option" :class="{ 'is-selected': isShowLang === 'bur' }" @click="changeLanguage('bur')">
            <img :src="isShowLang === 'bur' ? '../../static/images/account/mm_langauge_select.png' : '../../static/images/account/mm_langauge.png'" alt="Myanmar">
            <span>{{$t('Myanmar')}}</span>
          </button>
        </div>
        <div class="account-policy-links" aria-label="Help links">
          <button type="button" :aria-label="$t('AccountTC')" @click="getMenu('/termsAndCondition')">{{$t('AccountTC')}}</button>
          <button type="button" :aria-label="$t('AccountFAQ')" @click="getMenu('/faq')">{{$t('AccountFAQ')}}</button>
        </div>
      </section>

      <button type="button" class="account-unsubscribe" @click="unSubscribe">
        <img src="../../static/images/account/unsub_btn.png" alt="">
        <span>{{$t('Unsubscribe')}}</span>
      </button>
    </main>
  </div>
</template>
<script>
import Header from '../components/HeaderTwo'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          isEdit:false,
          info:'',
          nickname:'',
          base64Image:'',
          show_usub:false,
          isShowLang: localStorage.getItem('lang') || 'bur'
        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();

	},
    methods: {
      handleFileUpload(event) {
        let that = this;
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log(e);
            this.base64Image = e.target.result;

            // 从Base64字符串中提取图片类型
            const matches = this.base64Image.match(/^data:image\/([A-Za-z-+/]+);base64,/);
            const type = matches ? matches[1] : '';

            that.uploadImage(type);
          };
          reader.readAsDataURL(file);
        }
      },

      async uploadImage(imageType) {
        let that = this
        if (!this.base64Image) {
          alert('请先选择图片');
          return;
        }
        try {
          let data = {
            image: {
              "content": this.base64Image,
              "type": imageType || "" // 使用提取的类型，如果没有则留空
            }
          }
          that.$parent.loadModal(true);
          that.$api.post('/api/user/upload_avatar', data, r => {
            that.$parent.returnCode(r, function() {
              console.log('上传成功', r.data);
              that.getHome()
              that.$parent.loadModal(false);
            });
          })
        } catch (error) {
          console.error('上传失败', error);
        }
      },
		back(){
			this.$router.go(-1);
		},
    changeLanguage(lang){
      if (this.isShowLang === lang) return
      localStorage.setItem('lang', lang)
      location.reload()
    },
    getMenu(url){
      let that = this
      setTimeout(function(){
        that.$router.push({path: url, query: {url: url}})
      }, 500)
    },
    unSubscribe(){
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('api/user/unsub', null, r => {
        that.$parent.returnCode(r, function(){
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 80);
          localStorage.removeItem('token')
          localStorage.removeItem('mobile')
          window.location.href = "/"
        });
      })
    },
    editName(){
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub(){
      let that =this;
      let data = {
        nickname:that.nickname
      }
      //that.$parent.loadModal(true);
      that.$api.post('/api/user/profile',data,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.info = r.data
          that.isEdit = false
          that.getHome()
      		that.$parent.loadModal(false);
        });

      })
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
          that.show_usub = r.data.show_usub
        });

			})
		},
	}
}
</script>
<style scoped>
.account-page {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 46px 28px 70px;
  color: #fff;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, Atom-sans, sans-serif;
}
.account-main { width: min(100%, 640px); margin: 0 auto; }
.account-back { position: absolute; z-index: 2; top: 52px; left: 32px; width: 72px; height: 72px; padding: 0; border: 0; background: transparent; }
.account-back img { display: block; width: 100%; height: 100%; object-fit: contain; }
.account-title-wrap { display: flex; min-height: 200px; align-items: center; justify-content: center; }
.account-title-wrap img { display: block; width: min(94vw, 610px); height: auto; }
.account-user { display: flex; align-items: center; flex-direction: column; margin-top: 20px; }
.account-avatar-wrap { position: relative; width: 194px; height: 194px; }
.account-avatar { display: block; box-sizing: border-box; width: 100%; height: 100%; padding: 5px; border: 3px solid #fff; border-radius: 50%; background: #211d32; object-fit: cover; }
.account-camera { position: absolute; right: -8px; bottom: -4px; display: block; width: 75px; height: 75px; }
.account-camera img { display: block; width: 100%; height: 100%; object-fit: contain; }
.account-page .upload-image { position: absolute; right: -8px; bottom: -4px; z-index: 1; width: 75px; height: 75px; padding: 0; cursor: pointer; opacity: 0; }
.account-nickname { width: 100%; margin-top: 28px; text-align: center; }
.account-name-display { display: inline-flex; max-width: 100%; align-items: center; gap: 14px; color: #fff; font-size: 39px; font-weight: 800; }
.account-name-display > span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.account-edit { width: 42px; height: 42px; flex: 0 0 auto; padding: 0; border: 0; background: transparent; }
.account-edit img { display: block; width: 100%; height: 100%; object-fit: contain; }
.account-edit-form { display: flex; width: min(100%, 510px); gap: 12px; margin: 0 auto; }
.account-name-input { min-width: 0; flex: 1; padding: 14px 18px; border: 2px solid #fff; border-radius: 26px; outline: 0; background: rgba(35, 31, 54, .92); color: #fff; font-size: 28px; }
.account-submit { min-width: 126px; padding: 0 16px; border: 0; border-radius: 26px; background: #f01e80; color: #fff; font-size: 22px; font-weight: 800; }
.account-stats { display: flex; min-height: 198px; align-items: center; justify-content: space-around; margin-top: 34px; padding: 18px 22px; background: url('../../static/images/account/infos_bg.png') no-repeat center center; background-size: 100% 100%; }
.account-stat { display: flex; width: 30%; align-items: center; flex-direction: column; text-align: center; }
.account-stat > img { width: 88px; height: 88px; object-fit: contain; }
.account-stat:nth-of-type(3) > img { width: 92px; }
.account-stat span { margin-top: 5px; color: #fff; font-size: 27px; font-weight: 700; }
.account-stat strong { margin-top: 6px; color: #ffcb00; font-size: 40px; font-style: italic; font-weight: 900; line-height: 1; }
.account-stat-divider { width: 1px; height: 115px; background: rgba(255, 255, 255, .75); }
.account-details { margin-top: 22px; padding: 24px 34px 22px; border: 2px solid rgba(255, 255, 255, .9); border-radius: 42px; background: rgba(4, 2, 26, .72); }
.account-detail-row { display: flex; min-height: 62px; align-items: center; gap: 20px; margin: 12px 0; }
.account-detail-row > span { min-width: 190px; color: #fff; font-size: 26px; font-weight: 700; }
.account-detail-row strong { display: flex; min-width: 0; flex: 1; min-height: 62px; align-items: center; justify-content: center; padding: 0 14px; overflow: hidden; background: url('../../static/images/account/info_bg.png') no-repeat center center; background-size: 100% 100%; color: #ffcf00; font-size: 28px; font-style: italic; font-weight: 900; text-overflow: ellipsis; white-space: nowrap; }
.account-unsub-tip { margin: 14px 0 0; color: #ffcf00; font-size: 20px; text-align: center; }
.account-language { margin-top: 22px; padding-top: 30px; overflow: hidden; border: 2px solid rgba(255, 255, 255, .9); border-radius: 42px; background: url('../../static/images/account/language_bg.png') no-repeat center center; background-size: 100% 100%; }
.account-language h2 { margin: 0; color: #ffcf00; font-size: 30px; font-weight: 700; text-align: center; }
.account-language-options { display: flex; justify-content: center; gap: 95px; padding: 32px 30px 26px; }
.account-language-option { display: flex; align-items: center; flex-direction: column; padding: 0; border: 0; background: transparent; color: #fff; font-size: 27px; font-weight: 700; }
.account-language-option:focus-visible { outline: 3px solid #ffcf00; outline-offset: 5px; border-radius: 50%; }
.account-language-option img { width: 128px; height: 128px; object-fit: contain; }
.account-language-option span { margin-top: 12px; }
.account-language-option.is-selected { color: #00e881; }
.account-policy-links { display: flex; margin-top: 22px; padding-bottom: 24px; }
.account-policy-links button { display: flex; width: 50%; height: 74px; align-items: center; justify-content: center; padding: 0; border: 0; background: url('../../static/images/account/faq_tc_btn.png') no-repeat center center; background-size: 88% auto; color: #fff; cursor: pointer; font-size: 28px; font-weight: 800; }
.account-unsubscribe { position: relative; display: block; width: min(70%, 350px); margin: 30px auto 0; padding: 0; border: 0; background: transparent; cursor: pointer; }
.account-unsubscribe img { display: block; width: 100%; height: auto; }
.account-unsubscribe span { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 31px; font-weight: 900; text-shadow: 0 3px 2px rgba(0, 0, 0, .8); }
@media (max-width: 560px) {
  .account-page { padding: 34px 18px 48px; }
  .account-back { top: 38px; left: 24px; width: 54px; height: 54px; }
  .account-title-wrap { min-height: 152px; }
  .account-title-wrap img { width: 104vw; }
  .account-user { margin-top: 12px; }
  .account-avatar-wrap { width: 142px; height: 142px; }
  .account-camera { width: 58px; height: 58px; }
  .account-page .upload-image { width: 58px; height: 58px; }
  .account-nickname { margin-top: 19px; }
  .account-name-display { gap: 10px; font-size: 28px; }
  .account-edit { width: 31px; height: 31px; }
  .account-edit-form { gap: 8px; }
  .account-name-input { padding: 10px 12px; border-radius: 18px; font-size: 19px; }
  .account-submit { min-width: 82px; border-radius: 18px; font-size: 16px; }
  .account-stats { min-height: 145px; margin-top: 23px; padding: 12px 14px; }
  .account-stat > img { width: 62px; height: 62px; }
  .account-stat:nth-of-type(3) > img { width: 66px; }
  .account-stat span { margin-top: 2px; font-size: 19px; }
  .account-stat strong { margin-top: 4px; font-size: 28px; }
  .account-stat-divider { height: 88px; }
  .account-details { margin-top: 16px; padding: 16px 20px; border-radius: 28px; }
  .account-detail-row { min-height: 45px; gap: 10px; margin: 9px 0; }
  .account-detail-row > span { min-width: 122px; font-size: 18px; }
  .account-detail-row strong { min-height: 45px; padding: 0 9px; font-size: 18px; }
  .account-unsub-tip { font-size: 14px; }
  .account-language { margin-top: 16px; padding-top: 20px; border-radius: 28px; }
  .account-language h2 { font-size: 22px; }
  .account-language-options { gap: 56px; padding: 22px 18px 20px; }
  .account-language-option { font-size: 20px; }
  .account-language-option img { width: 104px; height: 104px; }
  .account-language-option span { margin-top: 7px; }
  .account-policy-links { margin-top: 24px; padding-bottom: 28px; }
  .account-policy-links button { height: 54px; font-size: 20px; }
  .account-unsubscribe { width: min(76%, 300px); margin-top: 22px; }
  .account-unsubscribe span { font-size: 22px; }
}
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue